module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAVRJREFUSEu9lb1KxEAUhb9VttXCSnFr0VcQHyBBGxu3mBAI4lO4lfgcCSQE0tgoyQOIr6DY6qqVhbbBH+7iQJDsrJHMTBeSOd+ck3vvDIAT+lmfwDvwAtwCr03ZQY+gpu4XcA/cAB/ywhZIQ5+BSmC2QQK8A65dgCTGCxegmStXoDcjaDgcDpRSoziOH0wdoJTaLIriqa5rialtmYtBBNI0nVRVden7/lWbQlmW+57nHURRdG460MLotFAbzPTu96EWgmRDm2AXSKeGbQrLRonLFOm/HOlNGibPXSCdHDUjtApyEp2TYnBS3mEYjpIkOf1LwwZBcJZl2XTeBJE+OgaW2j6QETQej2U6PJpGkBwoz/OpYQTNLr4jYLWf23y+ioD2gG0XoDXg8Odat8YTR7Ksu9KgZRlfwIYtSxok+gLbBbZsxNgEaTPyz3aAdWBlXul3df4NTYy7UfMF9HQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img_sc.png
// module id = 848
// module chunks = 1